var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Download bearbeiten"}},[_c('download-form',{attrs:{"loading":_vm.loading,"download":_vm.download,"form-submitted":_vm.saveDownload,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }